<template>
  <div class="collapse">
    <div v-for="(item,index) in menu" :key="index">
      <lk-dropdown placement="right-start" trigger="click" @on-click="toRouter">
        <div class="iconBtn">
          <a href="javascript:void(0)">
            <lk-icon :type="item.icon"></lk-icon>
            <span  v-html='item.icon' v-if="item.icon" class="iconfont"></span>
          </a>
        </div>
        <lk-dropdown-menu v-if="item.children&&item.children.length>0" slot="list">
          <div v-for="(subItem,i) in item.children" :key="i">
            <lk-dropdown placement="right-start" v-if="subItem.children&&subItem.children.length>0">
                <lk-dropdown-item href="javascript:void(0)">{{subItem.title}}
                   <lk-icon type="ios-arrow-forward"></lk-icon>
                </lk-dropdown-item>
                <lk-dropdown-menu  slot="list">
                  <div v-for="nextItem in subItem.children" :key="nextItem.name">
                      <lk-dropdown-item :name='nextItem.name'>{{nextItem.title}}</lk-dropdown-item>

                  </div>
                </lk-dropdown-menu>

            </lk-dropdown>
            <lk-dropdown-item v-else :name='subItem.name'>{{subItem.title}}</lk-dropdown-item>
          </div>


        </lk-dropdown-menu>
      </lk-dropdown>
    </div>
  </div>
</template>
<script>
export default {// 菜单暂时最多为3层
  name: 'collapsedMenu',
  computed: {
    menu() {
      return this.$store.state.app.menu;
    },
    routers() {
      return this.$store.state.app.routers;
    },
    routes() {
      return this.$route.path.split('/').slice(1);
    },
  },
  methods: {
    toRouter(name) {
      // console.log(name);

      this.$router.push({ name });
    },
  },
};
</script>
<style lang="less" scoped>
.collapse{
  z-index: 1000;
}
.iconBtn{
  height: 54px;
  width: 64px;
  >a{
    display: block;
    height: 100%;
    width: 100%;
    line-height: 54px;
    text-align: center
  }
}
</style>
